/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, shape, arrayOf, string, number, bool, func,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { uid } from 'react-uid';
import Cookies from 'universal-cookie';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getIsAuthenticatedStatus } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { actions as tagManagerActions } from '../../../../../state/ducks/TagManager';

const cookies = new Cookies();

const styles = ({ palette }) => ({
    addIcon: {
        justifyContent: 'flex-end',
        display: 'flex',
        color: palette.black,
        '& svg': {
            fontSize: '29px',
        },
    },
    mainLink: {
        padding: '14px 5px 14px 0px',
        borderBottom: `1px solid ${palette.cms?.tertiary_hover}`,
        margin: '4px 13px',
        '& a': {
            color: palette?.black,
        },
    },
    childLink: {
        margin: '9px 13px',
        padding: '4px 0px',
        '& a': {
            color: palette?.black,
        },
    },
});

const ExpansionPanel = withStyles(() => ({
    root: {
        boxShadow: 'none',
        backgroundColor: 'inherit',
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
}))(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles(({ palette }) => ({
    root: {
        backgroundColor: 'inherit',
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
        margin: '0px 12px',
        padding: '0px',
        '& h6': {
            fontSize: '18px',
        },
        borderBottom: `1px solid ${palette.cms?.tertiary_hover}`,
    },
    content: {
        '&$expanded': {
            margin: '12px 0px',
        },
    },
}))(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(() => ({
    root: {
        marginLeft: '15px',
        padding: '0px',
    },
}))(MuiExpansionPanelDetails);

class MobileFooterMenu extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            accordionActive: null,
        };
    }

    handleChangeExpansionPanel = (panel) => (event, newExpanded) => {
        this.setState({ accordionActive: ((newExpanded) ? panel : null) });
    };

    renderChildrenFooter = (menuItemObj, menuTitle, indexMenuParentItem) => {
        const { classes } = this.props;
        const { accordionActive } = this.state;
        const checkActiveTab = (accordionActive === indexMenuParentItem);
        return (
            <Grid item md={12} xs={12} key={uid(menuTitle, indexMenuParentItem)}>
                <ExpansionPanel expanded={checkActiveTab} onChange={this.handleChangeExpansionPanel(indexMenuParentItem)}>
                    <ExpansionPanelSummary aria-controls="mobile-footer-item" id={`mobile-footer-${indexMenuParentItem}`}>
                        <Grid container>
                            <Grid item md={11} xs={10}>
                                <Typography variant="subtitle1">
                                    {menuTitle}
                                </Typography>
                            </Grid>
                            <Grid item md={1} xs={2} className={classes.addIcon}>
                                {(checkActiveTab) ? <RemoveIcon /> : <AddIcon />}
                            </Grid>
                        </Grid>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid item md={12} xs={12}>
                            {(menuItemObj && menuItemObj.length > 0)
                                && menuItemObj.map((subMenuItem, subMenuItemIndex) => (this.renderMainLink(subMenuItem?.link, subMenuItemIndex, classes.childLink)))}
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </Grid>
        );
    };

    renderMainLink = (mainLinkObj, indexMenuParentItem, className = '') => {
        const { isAuthenticated } = this.props;
        const handleDoNotSellMyInformationClick = () => {
            const current = new Date();
            const next2Years = new Date();
            next2Years.setFullYear(current.getFullYear() + 2); // 2 years

            cookies.set('DoNotSell', 'Yes', {
                expires: next2Years,
            });
        };

        if ((mainLinkObj?.title === 'Sign In' && isAuthenticated) || (mainLinkObj?.title === 'Sign Out' && !isAuthenticated)) {
            return null;
        }
        const footerLinkClickHandler = (mainLinkObject) => {
            const { trackEvent } = this.props;
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: mainLinkObj?.tracking_event_category || 'Global Footer',
                eventAction: mainLinkObj?.tracking_event_action || mainLinkObject?.title || '',
                eventLabel: mainLinkObj?.tracking_event_label || mainLinkObject?.title || '',
            });
            if (mainLinkObject?.title === 'Do Not Sell My Personal Information') {
                return handleDoNotSellMyInformationClick();
            }

            return undefined;
        };

        return (
            <Grid key={uid(mainLinkObj, indexMenuParentItem)} item xs={12} className={className}>
                <Typography
                    component="a"
                    href={mainLinkObj?.href}
                    onClick={() => footerLinkClickHandler(mainLinkObj)}
                >
                    {mainLinkObj?.title}
                </Typography>
            </Grid>
        );
    };

    renderFooterMenu = (menuData) => {
        const { classes } = this.props;
        return (menuData.map((menuParentItem, indexMenuParentItem) => {
            const menuGroups = menuParentItem?.menu_groups;
            const menuItem = menuGroups?.menu_item;
            const mainLink = menuGroups?.main_link;
            const menuTitle = menuGroups?.title;
            return ((menuItem && menuItem.length > 0) ? this.renderChildrenFooter(menuItem, menuTitle, indexMenuParentItem) : this.renderMainLink(mainLink, indexMenuParentItem, classes.mainLink));
        }));
    }

    render() {
        const { menuData } = this.props;
        const menuBlockData = menuData?.menu_group_link_ref[0]?.menu_blocks;
        return ((menuBlockData && menuBlockData.length > 0) ? this.renderFooterMenu(menuBlockData) : <></>);
    }
}

MobileFooterMenu.propTypes = {
    classes: object.isRequired,
    menuData: shape({
        menu_group_link_ref: arrayOf(shape({
            background_color: object,
            default_text_color: object,
            locale: string,
            menu_blocks: arrayOf(shape({
                menu_groups: shape({
                    column: number,
                    icon: string,
                    is_heading: bool,
                    link: object,
                    link_style: object,
                    placement: string,
                    sub_menu: bool,
                }).isRequired,
            })).isRequired,
        })).isRequired,
    }).isRequired,
    isAuthenticated: bool.isRequired,
    trackEvent: func.isRequired,
};
const mapStateToProps = (state) => ({
    isAuthenticated: getIsAuthenticatedStatus(state),
});

const mapDispatchToProps = {
    trackEvent: tagManagerActions.trackEvent,
};
const enhance = compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
);
export default enhance(MobileFooterMenu);
